import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { SaveMapButton as Button } from 'ui-components'
import { useAuth, useFederatedAuth } from 'user-auth'
import { useIsEmbedding } from '~map-preview/hooks/useIsEmbedding'
import { useIsMapSaved } from '~map-preview/states/map'
import { openMapSaveDrawer, useIsFullscreen } from '~map-preview/states/ui'

const MapSaveButton = render(() => {
  const router = useRouter()
  const dispatch = useDispatch()

  const { gotoSignInPage } = useFederatedAuth()
  const { authenticated } = useAuth()

  const handleClick = () => {
    if (!authenticated) {
      gotoSignInPage({ redirect: router.asPath + '?save=true' })
      return
    }

    dispatch(openMapSaveDrawer())
  }

  return <Button onClick={handleClick} />
})

function render(Component) {
  return (props) => {
    const isMapSaved = useIsMapSaved()
    const isEmbedding = useIsEmbedding()
    const isFullscreen = useIsFullscreen()

    if (isEmbedding && !isFullscreen) return null
    if (isMapSaved) return null

    return <Component {...props} />
  }
}

export { MapSaveButton }
